import { Suspense, useState } from "react"
import { ArrowLeft } from "react-feather"
import { useNavigate, useParams } from "react-router-dom"
import { ticketApi } from "@/api/client/ticket"
import {
  TicketGetWithOcAssignee,
  TicketGetWithOwner,
  TicketGetWithProperty,
  TicketGetWithRoom,
  TicketGetWithTenant,
  TicketGetWithTicketComments,
} from "@/api/generated/models"
import { Button } from "@/components/ui/button"
import { ReactErrorBoundary } from "@/components/ui/error-boundary"
import { SectionLoading } from "@/components/ui/loading"
import { Tabs } from "@/components/ui/tabs"
import { TicketDetailContent } from "./components/TicketDetailContent"

type ActiveTabType = "progress" | "info"

export function TicketDetailPage() {
  const { ticketId } = useParams<{ ticketId: string }>()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState<ActiveTabType>("progress")

  // ticketIdのチェックとヘッダー取得用のクエリ
  const { data } = ticketApi.useTicketGet(
    ticketId || "",
    {
      withOwner: TicketGetWithOwner.true,
      withProperty: TicketGetWithProperty.true,
      withRoom: TicketGetWithRoom.true,
      withTenant: TicketGetWithTenant.true,
      withOcAssignee: TicketGetWithOcAssignee.true,
      withTicketComments: TicketGetWithTicketComments.true,
    },
    {
      query: {
        enabled: !!ticketId,
        select: (data) => ({ ticket: { title: data.ticket?.title, id: data.ticket?.id } }),
      },
    }
  )

  if (!ticketId) {
    return (
      <div className="flex items-center justify-center h-screen">案件IDが指定されていません</div>
    )
  }

  return (
    <div className="flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            className="p-0 w-7 h-7"
            onClick={() => navigate("/tickets")}
          >
            <ArrowLeft size={16} />
          </Button>
          <div className="flex items-center gap-3">
            <h1 className="text-lg font-semibold">{data?.ticket?.title || "案件詳細"}</h1>
            <span className="text-sm text-slate-400 font-semibold">
              ID：{data?.ticket?.id || ticketId}
            </span>
          </div>
          <Tabs
            items={[
              { value: "progress", label: "案件進捗" },
              { value: "info", label: "情報" },
            ]}
            value={activeTab}
            variant="small"
            onValueChange={(v) => setActiveTab(v as ActiveTabType)}
            className="ml-3"
          />
        </div>
        {/* TODO: フェーズ2 */}
        {/* <Button variant="outline" size="sm" className="gap-2">
          業者へメール
        </Button> */}
      </div>

      {/* Main Content */}
      <ReactErrorBoundary>
        <Suspense fallback={<SectionLoading />}>
          <TicketDetailContent activeTab={activeTab} />
        </Suspense>
      </ReactErrorBoundary>
    </div>
  )
}
